document.addEventListener('DOMContentLoaded', function () {

  const socialProofs = document.querySelectorAll('.as-product-social-proof');

  if (!socialProofs.length) return;

  socialProofs.forEach(function (wrapper) {

    /* -----------------------------
       Format Number
    ------------------------------ */

    function formatNumber(number) {
      return Math.floor(number).toLocaleString('en-US') + '+';
    }

    /* -----------------------------
       Calculate Dynamic Value
       Updates every 15 days
    ------------------------------ */

    function calculateValue(startNumber, incrementValue, startDate) {

      if (!startDate) return Number(startNumber);

      const start = new Date(startDate + 'T00:00:00');
      const today = new Date();

      // Ignore time portion
      start.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const diffTime = today.getTime() - start.getTime();
      const daysPassed = Math.max(0, Math.floor(diffTime / 86400000));

      // Increase once every 15 days
      const periodsPassed = Math.floor(daysPassed / 15);

      return Number(startNumber) + (periodsPassed * Number(incrementValue));
    }

    /* -----------------------------
       Added To Cart
    ------------------------------ */

    const cartElement = wrapper.querySelector('.as-cart-number');

    if (cartElement) {

      const value = calculateValue(
        wrapper.dataset.cartStart,
        wrapper.dataset.cartIncrement,
        wrapper.dataset.cartDate
      );

      cartElement.textContent = formatNumber(value);
    }

    /* -----------------------------
       Bought
    ------------------------------ */

    const buyElement = wrapper.querySelector('.as-buy-number');

    if (buyElement) {

      const value = calculateValue(
        wrapper.dataset.buyStart,
        wrapper.dataset.buyIncrement,
        wrapper.dataset.buyDate
      );

      buyElement.textContent = formatNumber(value);
    }

  });

});